import { styled } from 'styled-components'

import { Button } from '@/components/ui/button'

import { ComponentVisualState } from './dropzone.types'

interface ContainerProps {
  readonly $state: ComponentVisualState
  readonly $atCapacity: boolean
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[4]};
  padding: ${({ theme }) => `${theme.space[24]} ${theme.space[20]}`};
  width: 100%;
  border-radius: ${({ theme }) => theme.border.radius[12]};
  border: ${({ theme }) => theme.border.size[1]} dashed
    ${({ $state, $atCapacity, theme }) =>
      $state === 'disabled' || $atCapacity ? theme.colors.gray200 : theme.colors.gray500};
  background-color: ${({ $state, $atCapacity, theme }) =>
    $state === 'disabled' || $atCapacity ? theme.colors.gray300 : theme.colors.gray100};
  cursor: ${({ $state, $atCapacity }) =>
    $state === 'disabled' || $atCapacity ? 'not-allowed' : 'pointer'};
  transition: all ${({ theme }) => theme.transition.duration.sm} ease;
  outline: none;
  text-align: center;

  &:hover:not([data-disabled='true']):not([data-at-capacity='true']) {
    border-color: ${({ theme }) => theme.colors.blue500};
    background-color: ${({ theme }) => theme.colors.blue100};
  }

  &:focus-visible {
    box-shadow: 0 0 0 ${({ theme }) => theme.border.size[3]} ${({ theme }) => theme.colors.blue200};
    border-color: ${({ theme }) => theme.colors.blue500};
  }

  &[data-drag='true'] {
    border-color: ${({ theme }) => theme.colors.blue500} !important;
    background-color: ${({ theme }) => theme.colors.blue100} !important;
    transform: scale(1.003);
  }
`

export const IconTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.space[4]};
`

export const BrowseLibraryButton = styled(Button)`
  min-width: 26.6rem;
`

export const IconBox = styled.div<{ readonly $disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.space[8]};
  border-radius: ${({ theme }) => theme.border.radius[8]};
  background-color: ${({ $disabled, theme }) =>
    $disabled ? theme.colors.black300 : theme.colors.blue500};
`
